import { render, staticRenderFns } from "./MenuLevel1.vue?vue&type=template&id=523d1b84&"
import script from "./MenuLevel1.vue?vue&type=script&lang=js&"
export * from "./MenuLevel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports